export const handleWindowOpen = (windowHandle: Window | null) => {
  const sessionStorageCurrentDentalOffice = sessionStorage.getItem('currentDentalOffice');
  if(windowHandle && sessionStorageCurrentDentalOffice) {
    windowHandle.sessionStorage.setItem('currentDentalOffice', sessionStorageCurrentDentalOffice);
  }
};